export default "__VITE_ASSET__DFsLPE0b__"